export default "__VITE_ASSET__CMT17$Ui__"